module.exports = __webpack_public_path__ + "img/unit_White.4fa290ab.png";